export enum RouterId {
  WORKSPACE_BOARDS = 'workspace-boards',
  WORKSPACE_BOARD = 'workspace-board',
  WORKSPACE_SETTINGS = 'workspace-settings',
  WORKSPACE_MEMBERS = 'workspace-members',
}